import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from "@lexical/list";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Icon } from "../../../../../Icon/index.js";
const blockListTypeToBlockName = {
    bullet: 'Маркированный список',
    number: 'Нумерованный список',
    paragraph: ''
};
const getListIcon = (listType, theme, activeList)=>{
    const getColor = (item, activeItem)=>item === activeItem ? 'original.brand.primary' : 'text.light.primary';
    switch(listType){
        case 'bullet':
            return /*#__PURE__*/ jsx(Icon, {
                name: "list_outline",
                size: "20",
                color: getColor('bullet', activeList)
            });
        case 'number':
            return /*#__PURE__*/ jsx(Icon, {
                name: "list_number_outline",
                size: "20",
                color: getColor('number', activeList)
            });
        default:
            return /*#__PURE__*/ jsx(Icon, {
                name: "list_outline",
                size: "20",
                color: "text.light.primary"
            });
    }
};
const useList = (editor, blockListType)=>{
    const $ = c(13);
    const theme = useTheme();
    let t0;
    if ($[0] !== blockListType || $[1] !== editor) {
        t0 = (listType)=>{
            if ("bullet" === listType && "bullet" !== blockListType) return void editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, void 0);
            if ("number" === listType && "number" !== blockListType) return void editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, void 0);
            editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0);
        };
        $[0] = blockListType;
        $[1] = editor;
        $[2] = t0;
    } else t0 = $[2];
    const handleListFormat = t0;
    let t1;
    if ($[3] !== blockListType || $[4] !== handleListFormat || $[5] !== theme) {
        t1 = Object.entries(blockListTypeToBlockName).map((t2)=>{
            const [listType_0, name] = t2;
            if ("paragraph" === listType_0) return null;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: ()=>handleListFormat(listType_0),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    gap: "8",
                    children: [
                        getListIcon(listType_0, theme, blockListType),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            color: blockListType === listType_0 ? "original.brand.primary" : "text.light.primary",
                            children: name
                        })
                    ]
                })
            }, listType_0);
        });
        $[3] = blockListType;
        $[4] = handleListFormat;
        $[5] = theme;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== blockListType || $[8] !== theme) {
        t2 = getListIcon(blockListType, theme);
        $[7] = blockListType;
        $[8] = theme;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2) {
        t3 = [
            t1,
            t2
        ];
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
export { blockListTypeToBlockName, getListIcon, useList };
